import React, { useState, useEffect } from "react";

// Images
import fleche from "/equipes/fleche.svg";
import { MdDeleteForever } from "react-icons/md";

interface MultiLineProps {
  iconIndex: number;
  equipes: string[];
  equipesNom: string[];
  setIconIndex: (newIndex: number) => void;
  onArrowClick: (index: number) => void;
  onDelete: () => void;
}

const MultiLine: React.FC<MultiLineProps> = ({
  iconIndex,
  setIconIndex,
  equipes,
  equipesNom,
  onArrowClick,
  onDelete,
}) => {
  const [currentIconIndexLocal, setCurrentIconIndexLocal] =
    useState<number>(iconIndex);

  const handlePreviousClick = () => {
    const newIndex =
      currentIconIndexLocal === 0
        ? equipes.length - 1
        : currentIconIndexLocal - 1;
    setCurrentIconIndexLocal(newIndex);
    setIconIndex(newIndex);
    onArrowClick(newIndex);
  };

  const handleNextClick = () => {
    const newIndex =
      currentIconIndexLocal === equipes.length - 1
        ? 0
        : currentIconIndexLocal + 1;
    setCurrentIconIndexLocal(newIndex);
    setIconIndex(newIndex);
    onArrowClick(newIndex);
  };

  useEffect(() => {
    setCurrentIconIndexLocal(iconIndex); // Mettre à jour l'état local lorsque iconIndex change
  }, [iconIndex]);

  const handleDeleteClick = () => {
    onDelete(); // Appeler la fonction de suppression lors du clic sur le bouton
  };

  return (
    <ul className="multi__list">
      <li className="multi__click" onClick={handlePreviousClick}>
        <img src={fleche} alt={fleche} />
      </li>
      {equipes.map((equipe, index) => (
        <li
          className={`multi__icon ${
            index === currentIconIndexLocal ? "active" : ""
          }`}
          style={{ display: index === currentIconIndexLocal ? "flex" : "none" }}
          key={index}
        >
          <img src={equipe} alt={`Equipe ${index}`} />
        </li>
      ))}
      <li className="multi__fleche multi__click" onClick={handleNextClick}>
        <img src={fleche} alt={fleche} />
      </li>
      {equipesNom.map((equipe, index) => (
        <li
          className={`${index === currentIconIndexLocal ? "active" : ""}`}
          style={{ display: index === currentIconIndexLocal ? "flex" : "none" }}
          key={index}
        >
          <p className="icon--margin">Équipe {`${equipe}`}</p>
        </li>
      ))}
      <li onClick={handleDeleteClick}>
        <MdDeleteForever />
      </li>
    </ul>
  );
};

export default MultiLine;
